import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const GraphGlyph = /*#__PURE__*/createElement("g", {
  id: "Graph"
}, /*#__PURE__*/createElement("path", {
  d: "M67.92,62.32H21.68V16.08c0-0.8-0.65-1.46-1.46-1.46s-1.45,0.65-1.45,1.46v46.24h-2.69c-0.8,0-1.46,0.65-1.46,1.46 s0.65,1.46,1.46,1.46h2.69v2.69c0,0.8,0.65,1.46,1.45,1.46s1.46-0.65,1.46-1.46v-2.69h46.24c0.8,0,1.46-0.65,1.46-1.46 S68.72,62.32,67.92,62.32z"
}), /*#__PURE__*/createElement("path", {
  d: "M29.6,50.93c0.23,0.14,0.5,0.21,0.78,0.21c0.53,0,1.03-0.28,1.31-0.74l6.6-11.08l8.76,8.21l7.43-16.44l5.78,5.64 c0.29,0.28,0.72,0.44,1.08,0.43c0.41,0,0.79-0.17,1.07-0.46c0.58-0.6,0.57-1.56-0.02-2.15l-8.88-8.68l-7.47,16.53l-8.42-7.9 l-8.53,14.33C28.64,49.56,28.88,50.5,29.6,50.93z"
}));
const Graph = createSvg({
  name: 'graph',
  path: GraphGlyph
});

export default Graph;
export { GraphGlyph };
